module.exports = __webpack_public_path__ + "static/media/patch_cords_fiber.4f3dcb56.webp";